import { useEffect, useRef, useState } from 'react';

// Drives a resend-button cooldown: call start(seconds) after a successful
// send, secondsLeft counts down to 0 and the caller re-enables the button.
const useCooldown = () => {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => () => clearInterval(intervalRef.current), []);

  const start = (seconds) => {
    clearInterval(intervalRef.current);
    setSecondsLeft(seconds);
    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return { secondsLeft, start };
};

export default useCooldown;
